export default "__VITE_ASSET__c00f2ea4__"